// extracted by mini-css-extract-plugin
module.exports = {"about":"AboutUs_about__20cgk","aboutBody":"AboutUs_aboutBody__2TIqa","aboutParagraph":"AboutUs_aboutParagraph__yIiLK"};